<template>
  <div class="text-xs-center">
    <v-navigation-drawer
      temporary
      fixed
      enable-resize-watcher
      v-model="sideNav"
    >
      <v-list>
        <v-list-tile @click.stop="sideNav = !sideNav" color="black">
          <v-list-tile-action>
            <v-icon color="indigo">arrow_back</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile
          v-if="checkClient() == false && isLoggedIn"
          to="/project-list"
        >
          <v-list-tile-action>
            <v-icon color="indigo">home</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="checkClient() == true && isLoggedIn" to="/">
          <v-list-tile-action>
            <v-icon color="indigo">home</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile>

        <!-- <v-list-group color="indigo" prepend-icon="account_circle" value="true"> -->

        <v-list-group
          v-for="(menu, i) in getMenuData(getMenus)"
          :key="i"
          no-action
          sub-group
          value="true"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title v-if="isLoggedIn">{{
                menu.title
              }}</v-list-tile-title>
              <v-list-tile-action v-if="menu.icon">
                <v-icon color="indigo">{{ menu.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
          <div v-if="menu.items">
            <v-list-tile
              v-for="(item, index) in menu.items"
              :key="index"
              :to="item.link"
            >
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon color="indigo">{{ item.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </div>
          <v-list-tile :to="menu.link" v-else>
            <v-list-tile-title v-text="menu.title"></v-list-tile-title>
            <v-list-tile-action>
              <!-- <v-icon color="indigo">{{ menu.icon }}</v-icon> -->
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <!-- </v-list-group> -->
      </v-list>

      <v-btn v-if="isLoggedIn" flat @click="logout">
        <v-icon color="indigo" left>lock</v-icon>
        Signout
      </v-btn>
    </v-navigation-drawer>

    <v-toolbar :clipped-left="clipped" color="white">
      <v-toolbar-side-icon
        @click.stop="sideNav = !sideNav"
        color="white"
        class="hidden-md-and-up"
      ></v-toolbar-side-icon>
      <v-toolbar-side-icon @click="redirectToWebsite">
        <v-img
          color="#ff2e2e"
          :src="require('../assets/logo.png')"
          class="mx-1"
          contain
        ></v-img>
      </v-toolbar-side-icon>
      <v-toolbar-title v-if="isLoggedIn">
        <router-link
          color="#ff2e2e"
          to="/"
          tag="span"
          style="cursor: pointer; color: #ff2e2e"
          v-if="checkClient() == true"
        >
          DataDash Solution
        </router-link>
        <router-link
          color="#ff2e2e"
          to="/project-list"
          tag="span"
          style="cursor: pointer; color: #ff2e2e"
          v-else
        >
          DataDash Solution
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title
        v-if="!isLoggedIn"
        style="cursor: pointer; color: #ff2e2e"
      >
        DataDash Solution
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu open-on-hover offset-y v-if="isLoggedIn && !checkClient()">
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on" color="red" to="/project-list">project</v-btn>
        </template>
      </v-menu>
      <div
        v-for="(menu, i) in getMenuData(getMenus)"
        :key="i"
        class="hidden-sm-and-down floating text-xs-center"
      >
        <v-menu open-on-hover offset-y v-if="isLoggedIn">
          <template v-slot:activator="{ on }">
            <v-btn flat v-on="on" color="#ff2e2e">
              <v-icon color="indigo">{{ menu.icon }}</v-icon>
              {{ menu.title }}
            </v-btn>
          </template>

          <v-list style="max-height: 400px" class="scroll-y">
            <v-list-tile
              v-for="(item, index) in menu.items"
              :key="index"
              :to="item.link"
            >
              <v-list-tile-title>
                <v-icon color="indigo">{{ item.icon }}</v-icon>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn
          class="hidden-sm-and-down floating"
          flat
          v-else
          color="red"
          :to="menu.link"
        >
          <!-- <v-icon color="indigo">{{ menu.icon }}</v-icon> -->
          {{ menu.title }}
        </v-btn>
      </div>

      <v-menu
        open-on-hover
        offset-y
        v-if="isLoggedIn"
        class="hidden-sm-and-down"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            flat
            v-on="on"
            color="red"
            class="hidden-sm-and-down"
            to="/agent-management"
            >Agent</v-btn
          >
        </template>
      </v-menu>
      <v-menu
        open-on-hover
        offset-y
        v-if="isLoggedIn"
        class="hidden-sm-and-down"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            flat
            v-on="on"
            class="hidden-sm-and-down"
            color="red"
            to="/team-management"
            >Team</v-btn
          >
        </template>
      </v-menu>

      <v-menu
        open-on-hover
        offset-y
        v-if="isLoggedIn && checkClient() == false"
        class="hidden-sm-and-down"
      >
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on" color="red">
            <v-icon color="indigo"></v-icon>
            Reports
          </v-btn>
        </template>

        <v-list style="max-height: 400px" class="scroll-y">
          <v-list-tile to="/project-summary-report">
            <v-list-tile-title> Project Summary Report </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu
        open-on-hover
        offset-y
        v-if="isLoggedIn"
        class="hidden-sm-and-down"
      >
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on" class="hidden-sm-and-down" color="red">
            <v-icon color="indigo"></v-icon>
            User
          </v-btn>
        </template>

        <v-list style="max-height: 400px" class="scroll-y">
          <v-list style="max-height: 400px" class="scroll-y">
            <v-list-tile to="/profile">
              <v-list-tile-title>
                <v-icon color="indigo">person</v-icon>
                Profile
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile to="/profile/transaction">
              <v-list-tile-title>
                <v-icon color="indigo">currency_exchange</v-icon>
                Transactions
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile to="/subscription-package">
              <v-list-tile-title>
                <v-icon color="indigo">inventory_2</v-icon>
                Subscription Packages
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile to="/user-management">
              <v-list-tile-title>
                <v-icon color="indigo">group</v-icon>
                User Management
              </v-list-tile-title>
            </v-list-tile>
          </v-list>

          <v-list-tile to="/privacy-policy-en">
            <v-list-tile-title>
              <v-icon color="indigo">policy</v-icon>
              Privacy Policy
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/faq-client">
            <v-list-tile-title>
              <v-icon color="indigo">quiz</v-icon>
              FAQs
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>
              <v-icon color="indigo" left>lock</v-icon>
              Signout
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <Notification v-if="isLoggedIn" />
    </v-toolbar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Notification from "./Notification/AdminPanelNotification";
export default {
  components: {
    Notification,
  },
  data() {
    return {
      clipped: false,
      sideNav: false,
      fixed: false,
      clientId: null,
      admin_access: [
        "System Settings",
        "Project Settings",
        "Reports",
        "User Role",
        "Clementine",
        "Project",
      ],
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "clientID", "getMenus"]),
  },
  methods: {
    ...mapActions(["login", "logout"]),

    redirectToWebsite() {
      window.open("https://clementinedatabd.com/");
    },
    getMenuData(value) {
      var filterMemu = value;
      this.setSubscription();
      if (parseInt(localStorage.getItem("client_id")) != 1) {
        filterMemu = value.filter((element) => {
          return !this.admin_access.includes(element.title);
        });
        return filterMemu;
      }
      return value;
    },
    checkClient() {
      // console.log(localStorage.getItem("client_id"));
      return parseInt(localStorage.getItem("client_id")) == 1 ? true : false;
    },
    setSubscription() {
      if (this.isLoggedIn) {
        this.$store.dispatch("subscriptionData", "subscription-features");
      }

      // console.log("subscriptionData");
    },
    getYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
